import styled, { css } from 'styled-components';
import { Colors } from '../../../theme';
import { MENU_LAYOUT } from '../types';
const desktopStyles = css((props) => ({
    minWidth: 'auto',
    maxWidth: props.$layout === MENU_LAYOUT.Even ? 'auto' : '580px',
    padding: '0 16px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
    '.top': {
        flex: 1,
        padding: '8px 0',
        display: 'flex',
        boxSizing: 'border-box',
    },
    '.middle': {
        display: 'flex',
        boxSizing: 'border-box',
    },
    '.main': {
        flex: props.$layout === MENU_LAYOUT.Even ? '1' : '0 1 auto',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
    },
    '.sidebar': {
        maxWidth: props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px',
        minWidth: props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px',
        boxSizing: 'border-box',
        flex: props.$layout === MENU_LAYOUT.Even ? '1' : '0 0 200px',
        padding: props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px',
        borderTop: `solid 1px ${Colors.black40}`,
        borderLeft: `solid 1px ${Colors.black40}`,
    },
    '.bottom': {
        flex: 1,
        padding: 16,
        boxSizing: 'border-box',
        borderTop: `solid 1px ${Colors.black40}`,
    },
    '[role="menuitem"]': {
        outline: 'none',
        '&:focus': {
            outline: `2px solid ${Colors.blue300}`,
            outlineOffset: '2px',
        },
    },
}));
const mobileStyles = css((props) => ({
    minWidth: props.$layout === MENU_LAYOUT.Even ? '340px' : 'auto',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
    '.top': {
        padding: '0',
        boxSizing: 'border-box',
    },
    '.main': {
        flex: 1,
        padding: '4px 0',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
    },
    '.sidebar': {
        display: props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none',
        flexDirection: 'column',
        boxSizing: 'border-box',
        flex: 1,
        padding: props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px',
        borderLeft: `solid 1px ${Colors.black40}`,
    },
    '.bottom': {
        display: props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none',
        padding: '0 8px',
        boxSizing: 'border-box',
        '&:before': {
            content: "''",
            display: 'flex',
            margin: 8,
            borderBottom: `solid 1px ${Colors.black40}`,
        },
    },
    '[role="menuitem"]': {
        outline: 'none',
        '&:focus': {
            outline: `2px solid ${Colors.blue300}`,
            outlineOffset: '2px',
        },
    },
}));
export const Wrapper = styled.div((props) => (props.$isMobile === true ? mobileStyles : desktopStyles));
//# sourceMappingURL=styles.js.map